var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:[_vm.$style.container, { FormTextarea__error: this.error }]},[_c('label',{class:[
      _vm.$style.label,
      {
        FormTextarea__optional: this.optionalLabel
      }
    ],attrs:{"for":_vm.formTextareaId}},[_vm._v("\n    "+_vm._s(_vm.label)+"\n    "),(_vm.optionalLabel)?_c('span',[_vm._v("("+_vm._s(_vm.optionalLabel)+")")]):_vm._e()]),_c('textarea',{attrs:{"id":_vm.formTextareaId,"rows":_vm.rows,"columns":_vm.columns,"aria-label":_vm.ariaLabel},domProps:{"value":_vm.value},on:{"input":_vm.handleInput}}),(_vm.error)?_c('div',{class:_vm.$style.errorMessage},[_vm._v(_vm._s(_vm.errorMessage))]):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }